export const GET_GENERIC_MAILS_PENDING = 'get_generic_mails_pending';
export const GET_GENERIC_MAILS_SUCCESS = 'get_generic_mails_success';
export const GET_GENERIC_MAILS_FAILURE = 'get_generic_mails_failure';
